module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newship"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("\n    新建发货通知单\n  ")]), _vm._v(" "), _vm._l((_vm.Lines), function(item, index) {
    return _c('div', {
      staticClass: "card"
    }, [_c('el-form', {
      ref: "item.ruleForm",
      refInFor: true,
      staticClass: "applybox",
      attrs: {
        "inline": true,
        "model": item.ruleForm,
        "rules": item.rules
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "物流类型",
        "prop": "ShipmentMethod"
      }
    }, [_c('el-select', {
      staticClass: "form-input",
      attrs: {
        "placeholder": "请选择物流类型"
      },
      model: {
        value: (item.ruleForm.ShipmentMethod),
        callback: function($$v) {
          item.ruleForm.ShipmentMethod = $$v
        },
        expression: "item.ruleForm.ShipmentMethod"
      }
    }, _vm._l((_vm.LogisticsType), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1), _vm._v(" "), (item.ruleForm.ShipmentMethod != 'none') ? _c('el-form-item', {
      attrs: {
        "label": "配送类型",
        "prop": "deliverytype"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择配送类型"
      },
      model: {
        value: (item.ruleForm.deliverytype),
        callback: function($$v) {
          item.ruleForm.deliverytype = $$v
        },
        expression: "item.ruleForm.deliverytype"
      }
    }, _vm._l((_vm.deliverytypes), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1) : _vm._e(), _vm._v(" "), (item.ruleForm.ShipmentMethod == 'internal') ? _c('el-form-item', {
      attrs: {
        "label": "配送方式",
        "prop": "facilityId"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择配送类型"
      },
      model: {
        value: (item.ruleForm.facilityId),
        callback: function($$v) {
          item.ruleForm.facilityId = $$v
        },
        expression: "item.ruleForm.facilityId"
      }
    }, _vm._l((_vm.LogisticsFacility), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      })
    }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "联系人姓名",
        "prop": "ContactName"
      }
    }, [_c('el-input', {
      staticClass: "form-input",
      attrs: {
        "placeholder": "联系人姓名"
      },
      model: {
        value: (item.ruleForm.ContactName),
        callback: function($$v) {
          item.ruleForm.ContactName = $$v
        },
        expression: "item.ruleForm.ContactName"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "联系人电话",
        "prop": "ContactPhone"
      }
    }, [_c('el-input', {
      staticClass: "form-input",
      attrs: {
        "placeholder": "联系人电话"
      },
      model: {
        value: (item.ruleForm.ContactPhone),
        callback: function($$v) {
          item.ruleForm.ContactPhone = $$v
        },
        expression: "item.ruleForm.ContactPhone"
      }
    })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (item.ruleForm.ShipmentMethod === 'internal') ? _c('el-form-item', {
      attrs: {
        "label": "配送至网点",
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": true
      },
      model: {
        value: (item.ruleForm.ShipToPointOfSales),
        callback: function($$v) {
          item.ruleForm.ShipToPointOfSales = $$v
        },
        expression: "item.ruleForm.ShipToPointOfSales"
      }
    }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": false
      },
      model: {
        value: (item.ruleForm.ShipToPointOfSales),
        callback: function($$v) {
          item.ruleForm.ShipToPointOfSales = $$v
        },
        expression: "item.ruleForm.ShipToPointOfSales"
      }
    }, [_vm._v("否")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "width": "600px"
      },
      attrs: {
        "label": "联系地址",
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('address-box', {
      attrs: {
        "province-id": item.ruleForm.ProvinceId,
        "city-id": item.ruleForm.CityId,
        "county-id": item.ruleForm.CountyId,
        "point-id": item.ruleForm.PointOfSalesId,
        "address": item.ruleForm.StreetAddress,
        "show-point": item.ruleForm.ShipmentMethod === 'internal' && item.ruleForm.ShipToPointOfSales
      },
      on: {
        "update:provinceId": function($event) {
          item.ruleForm.ProvinceId = $event
        },
        "update:cityId": function($event) {
          item.ruleForm.CityId = $event
        },
        "update:countyId": function($event) {
          item.ruleForm.CountyId = $event
        },
        "update:pointId": function($event) {
          item.ruleForm.PointOfSalesId = $event
        },
        "update:address": function($event) {
          item.ruleForm.StreetAddress = $event
        }
      }
    })], 1)], 1), _vm._v(" "), _vm._l((item.tableData), function(data, index) {
      return _c('div', {
        staticClass: "item-box"
      }, [_c('table', [_vm._m(0, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n              " + _vm._s(data.ProductName)), _c('br'), _vm._v("物料编码： " + _vm._s(data.ProductCode) + "\n            ")]), _vm._v(" "), _c('td', [_c('el-tag', {
        attrs: {
          "type": _vm._f("ConditionColor")(data.ConditionName)
        }
      }, [_vm._v(_vm._s(data.ConditionName))])], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.ProductBrandName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.ProductModelName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.ProductModuleName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("InventorySource")(data.type)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.Quantity) + "\n            ")]), _vm._v(" "), _c('td', [_c('el-input', {
        attrs: {
          "placeholder": "数量"
        },
        on: {
          "change": function($event) {
            _vm.notOutpace(data)
          }
        },
        model: {
          value: (data.number),
          callback: function($$v) {
            data.number = _vm._n($$v)
          },
          expression: "data.number"
        }
      })], 1)])])]), _vm._v(" "), _c('el-button', {
        staticClass: "delete-btn",
        nativeOn: {
          "click": function($event) {
            _vm.deleteItem(index, data, item)
          }
        }
      }, [_vm._v("X")])], 1)
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addMariter(item, index)
        }
      }
    }, [_vm._v("添加物料")])], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addAddress()
      }
    }
  }, [_vm._v("新增地址")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n      客户订单号\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReferenceCode),
      expression: "ReferenceCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "客户订单号"
    },
    domProps: {
      "value": (_vm.ReferenceCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReferenceCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sumbit_box"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sumbit($event)
      }
    }
  }, [_vm._v("提交并等待客服联系")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pop-box",
    attrs: {
      "title": "发货物料",
      "size": "large"
    },
    model: {
      value: (_vm.ShipFormVisible),
      callback: function($$v) {
        _vm.ShipFormVisible = $$v
      },
      expression: "ShipFormVisible"
    }
  }, [_c('div', {
    staticClass: "review-table"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "type": "textarea",
      "placeholder": "物料名称"
    },
    model: {
      value: (_vm.sendForm.ProductName),
      callback: function($$v) {
        _vm.sendForm.ProductName = $$v
      },
      expression: "sendForm.ProductName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料编码"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "type": "textarea",
      "placeholder": "物料编码"
    },
    model: {
      value: (_vm.sendForm.ProductCode),
      callback: function($$v) {
        _vm.sendForm.ProductCode = $$v
      },
      expression: "sendForm.ProductCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品项"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择品项"
    },
    model: {
      value: (_vm.sendForm.ConditionName),
      callback: function($$v) {
        _vm.sendForm.ConditionName = $$v
      },
      expression: "sendForm.ConditionName"
    }
  }, _vm._l((_vm.ProductConditions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "库存来源"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "库存来源"
    },
    model: {
      value: (_vm.sendForm.inventorySource),
      callback: function($$v) {
        _vm.sendForm.inventorySource = $$v
      },
      expression: "sendForm.inventorySource"
    }
  }, _vm._l((_vm.InventorySources), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin": "0 30px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleSearch()
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('h5', [_vm._v("查询结果")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.appointlist,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-col', [_vm._v(_vm._s(prop.row.ProductName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料编码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_vm._v("\n            " + _vm._s(prop.row.ProductCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(prop.row.ConditionName)
          }
        }, [_vm._v(_vm._s(prop.row.ConditionName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_vm._v("\n            " + _vm._s(prop.row.ProductBrandName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_vm._v("\n            " + _vm._s(prop.row.ProductModelName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_vm._v("\n            " + _vm._s(prop.row.ProductModuleName) + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "text-right",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ShipFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureAdd()
      }
    }
  }, [_vm._v("确认")])], 1)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    attrs: {
      "width": "260"
    }
  }, [_vm._v("物料名称-编码")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("品项")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("品牌")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "140"
    }
  }, [_vm._v("机型")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("模块")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("库存来源")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80"
    }
  }, [_vm._v("库存数量")]), _vm._v(" "), _c('td', [_vm._v("发货数量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-281f8496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/NewShipPage.vue
// module id = 711
// module chunks = 0